import * as React from 'react';
import { Button, Card, IconButton, Tooltip } from 'wix-style-react';
import { ChevronRight } from 'wix-ui-icons-common';
import { DataHooks } from '../../constants/data-hooks';

import * as css from './section.scss';

export interface SectionProps {
  dataHook?: string;
  className?: string;
  actionHasIcon?: boolean;
  title: string;
  subtitle: string;
  actionText?: string;
  tooltip?: string;
  onButtonClicked(): void;
  disabled?: boolean;
}

export const SectionComponent = (props: SectionProps) => {
  const { tooltip, actionText, onButtonClicked, actionHasIcon = false, disabled = false } = props;

  const renderButtonWithText = () => (
    <Tooltip dataHook={DataHooks.SectionTooltip} appendTo="window" content={tooltip} disabled={!tooltip}>
      <Button
        dataHook={DataHooks.SectionButton}
        className={css.button}
        priority="secondary"
        skin="standard"
        onClick={onButtonClicked}
        suffixIcon={actionHasIcon ? <ChevronRight /> : undefined}
        disabled={disabled}
      >
        {actionText}
      </Button>
    </Tooltip>
  );

  const renderIconButton = () => (
    <IconButton
      dataHook={DataHooks.SectionIconButton}
      priority="secondary"
      skin="standard"
      onClick={onButtonClicked}
      disabled={disabled}
    >
      <ChevronRight />
    </IconButton>
  );

  const { title, subtitle, className, dataHook } = props;
  return (
    <Card className={className}>
      <Card.Header
        dataHook={dataHook}
        title={title}
        subtitle={subtitle}
        suffix={actionText ? renderButtonWithText() : renderIconButton()}
      />
    </Card>
  );
};
